import { Bounds, Browser, LatLngBounds, Map, Point } from 'leaflet';

/**
 * Convert to radians.
 */
const convertToRadians = value => (value * Math.PI) / 180;

/**
 * Calculate distance between two points.
 */
const calculateDistanceBetweenTwoPoints = ({ marker1, marker2 }) => {
  // Markers.
  const [lat1, long1] = marker1;
  const [lat2, long2] = marker2;

  // Earth's radius in km.
  const earthRadius = 6371;

  // Calculate distance.
  const dLat = convertToRadians(lat2 - lat1);
  const dLon = convertToRadians(long2 - long1);
  const latitude1 = convertToRadians(lat1);
  const latitude2 = convertToRadians(lat2);
  const valueX =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) *
      Math.sin(dLon / 2) *
      Math.cos(latitude1) *
      Math.cos(latitude2);
  const valueY = 2 * Math.atan2(Math.sqrt(valueX), Math.sqrt(1 - valueX));
  const distance = earthRadius * valueY;

  // Distance in meters.
  return distance * 1000;
};

/**
 * Get the best zoom that fits the bounds.
 */
const getBoundsZoom = (
  leafletMap: Map,
  bounds: LatLngBounds,
  padding: Point
) => {
  let zoom = leafletMap.getZoom() || 0;
  const max = leafletMap.getMaxZoom();
  const nw = bounds.getNorthWest();
  const se = bounds.getSouthEast();
  const size = leafletMap.getSize().subtract(padding);
  const boundsSize = new Bounds(
    leafletMap.project(se, zoom),
    leafletMap.project(nw, zoom)
  ).getSize();
  const snap = Browser.any3d ? leafletMap.options.zoomSnap : 1;
  const scalex = size.x / boundsSize.x;
  const scaley = size.y / boundsSize.y;
  const scale = Math.min(scalex, scaley);

  zoom = leafletMap.getScaleZoom(scale, zoom);

  if (snap) {
    zoom = Math.round(zoom / (snap / 100)) * (snap / 100);
    zoom = Math.floor(zoom / snap) * snap;
  }

  return Math.min(max, zoom);
};

/**
 * Popup renderer.
 */
const popupRenderer = ({ index, name }: { index: number; name: string }) => `
  <div id="pickupPopup${index}" style="margin: 0 16px">
    ${name} &nbsp; ➔
  </div>`;

/**
 * Export map utilities.
 */
export { calculateDistanceBetweenTwoPoints, getBoundsZoom, popupRenderer };
